var RequestType;
(function (RequestType) {
    RequestType[RequestType["GET_ORDER_OPTIONS"] = 0] = "GET_ORDER_OPTIONS";
    RequestType[RequestType["GET_VEHICLE_LOOKUP"] = 1] = "GET_VEHICLE_LOOKUP";
    RequestType[RequestType["GET_INSURANCE_OPTIONS"] = 2] = "GET_INSURANCE_OPTIONS";
    RequestType[RequestType["GET_ADDRESS_LOOKUP"] = 3] = "GET_ADDRESS_LOOKUP";
    RequestType[RequestType["GET_PAYMENT_LOOKUP"] = 4] = "GET_PAYMENT_LOOKUP";
    RequestType[RequestType["CREATE_ORDER"] = 5] = "CREATE_ORDER";
    RequestType[RequestType["BANK_ID_AUTH"] = 6] = "BANK_ID_AUTH";
    RequestType[RequestType["BANK_ID_COLLECT"] = 7] = "BANK_ID_COLLECT";
    RequestType[RequestType["BANK_ID_CANCEL"] = 8] = "BANK_ID_CANCEL";
    RequestType[RequestType["CREATE_CREDIT_ASSESSMENT_CASE"] = 9] = "CREATE_CREDIT_ASSESSMENT_CASE";
    RequestType[RequestType["DECLINE_CREDIT_ASSESSMENT_CASE"] = 10] = "DECLINE_CREDIT_ASSESSMENT_CASE";
    RequestType[RequestType["SIGN_CREDIT_ASSESSMENT_WITH_QR_CODE"] = 11] = "SIGN_CREDIT_ASSESSMENT_WITH_QR_CODE";
    RequestType[RequestType["SIGN_CREDIT_ASSESSMENT_WITH_SAME_DEVICE"] = 12] = "SIGN_CREDIT_ASSESSMENT_WITH_SAME_DEVICE";
    RequestType[RequestType["CANCEL_CREDIT_ASSESSMENT_SIGNING"] = 13] = "CANCEL_CREDIT_ASSESSMENT_SIGNING";
    RequestType[RequestType["GET_CREDIT_ASSESSMENT_STATUS"] = 14] = "GET_CREDIT_ASSESSMENT_STATUS";
})(RequestType || (RequestType = {}));
export default RequestType;
